import { getPropsFromParams } from '../utils.routing'

import { sharedRouteNames } from '../routeNames/sharedRouteNames'

import CanceledPayment from '../../components/accreditations/CanceledPayment.vue'
import FailedPayment from '../../components/accreditations/FailedPayment.vue'
import RegisterContainer from '../../components/accreditations/register-container/RegisterContainer.vue'
import CustomRegisterContainer from '../../components/accreditations/register-container/CustomRegisterContainer.vue'
import Error404 from './../../components/shared/404-page.vue'
import ForgotPasswordContainer from './../../components/user/ForgotPasswordContainer.vue'
import LoginContainer from './../../components/user/LoginContainer.vue'
import RecoverPasswordContainer from './../../components/user/RecoverPasswordContainer.vue'
import SignUpContainer from './../../components/user/SignUpContainer.vue'
import UserProfileContainer from './../../components/user/UserProfileContainer.vue'
import EditAttendeeData from '../../components/accreditations/register-stepper/edit-attendee-data.vue'
import AcceptInviteContainer from '../../components/user/AcceptInviteContainer.vue'
import SuccessfulSignUp from '../../components/user/SuccessfulSignUpContainer.vue'
import SignUpVerification from '../../components/user/SignUpVerificationContainer.vue'
import StoreContainer from '@/components/accreditations/organization-store/StoreContainer.vue'
import CuratedAttendeeInviteResponse from '@/components/accreditations/invite/CuratedAttendeeInviteResponse.vue'
import AnnualTicketInvite from '@/components/accreditations/invite/annual-ticket/annual-ticket-invite.vue'
import cyberGuardA1 from '@/components/shared/cyberGuardA1.vue'
import SportSubscriptionsStoreContainer from '@/components/accreditations/organization-store/SportSubscriptionsStoreContainer.vue'
import SportMembershipsStoreContainer from '@/components/accreditations/organization-store/SportMembershipsStoreContainer.vue'

export const SharedRoutes = [
  {
    path: '/events/:eventSlug/register',
    name: sharedRouteNames.register,
    props: getPropsFromParams,
    component: RegisterContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/test-konfa-45db',
    name: sharedRouteNames.cyberGuardA1,
    props: getPropsFromParams,
    component: cyberGuardA1,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/organization/:organizationSlug/store',
    name: sharedRouteNames.organizationStore,
    props: getPropsFromParams,
    component: StoreContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/organization/:organizationSlug/sport-subscriptions-store',
    name: sharedRouteNames.sportSubscriptionsStore,
    props: getPropsFromParams,
    component: SportSubscriptionsStoreContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/organization/:organizationSlug/sport-memberships-store',
    name: sharedRouteNames.sportMembershipsStore,
    props: getPropsFromParams,
    component: SportMembershipsStoreContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/events/:eventSlug/custom-register/:attendeeUUID',
    name: sharedRouteNames.customRegister,
    props: getPropsFromParams,
    component: CustomRegisterContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/events/:eventSlug/register/:attendeeUUID',
    name: sharedRouteNames.editAttendeeData,
    props: getPropsFromParams,
    component: EditAttendeeData,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/events/:eventSlug/register/:orderNumber/:status',
    name: sharedRouteNames.register,
    props: getPropsFromParams,
    component: RegisterContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/canceled-payment/:orderNumber',
    props: getPropsFromParams,
    name: sharedRouteNames.canceledPayment,
    component: CanceledPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/failed-payment/:orderNumber',
    props: getPropsFromParams,
    name: sharedRouteNames.failedPayment,
    component: FailedPayment,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/login',
    props: getPropsFromParams,
    name: sharedRouteNames.login,
    component: LoginContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: true,
      hideProAccountButton: true,
    },
  },
  {
    path: '/sign-up',
    props: getPropsFromParams,
    name: sharedRouteNames.signUp,
    component: SignUpContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: true,
      hideProAccountButton: true,
    },
  },
  {
    path: '/user-profile',
    name: sharedRouteNames.userProfile,
    component: UserProfileContainer,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/forgot-password',
    name: sharedRouteNames.forgotPassword,
    props: getPropsFromParams,
    component: ForgotPasswordContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/recover-password/:token',
    name: sharedRouteNames.recoverPassword,
    props: getPropsFromParams,
    component: RecoverPasswordContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/accept-invite/:token',
    name: sharedRouteNames.acceptInvite,
    props: getPropsFromParams,
    component: AcceptInviteContainer,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/invite-response/:eventId/:attendeeUUID/:status',
    name: sharedRouteNames.curatedInviteResponse,
    props: getPropsFromParams,
    component: CuratedAttendeeInviteResponse,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/annual-ticket-invite/:eventId/:attendeeUUID/:status',
    name: sharedRouteNames.annualTicketInvite,
    props: getPropsFromParams,
    component: AnnualTicketInvite,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/successful-sign-up',
    name: sharedRouteNames.successfulSignUp,
    props: getPropsFromParams,
    component: SuccessfulSignUp,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '/sign-up-verification/:token',
    name: sharedRouteNames.signUpVerification,
    props: getPropsFromParams,
    component: SignUpVerification,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
  {
    path: '*',
    redirect: { name: sharedRouteNames.error404 },
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/404',
    name: sharedRouteNames.error404,
    component: Error404,
    meta: {
      requiresAuthentication: false,
      redirectIfAuthenticated: false,
      hideProAccountButton: true,
    },
  },
]
